import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _146c3e07 = () => interopDefault(import('../../../pages/404.vue' /* webpackChunkName: "pages/404" */))
const _8d24550a = () => interopDefault(import('../../../pages/concretar-compra.vue' /* webpackChunkName: "pages/concretar-compra" */))
const _3c590a65 = () => interopDefault(import('../../../pages/confirmacion-contacto.vue' /* webpackChunkName: "pages/confirmacion-contacto" */))
const _5e59b1c6 = () => interopDefault(import('../../../pages/confirmacion-suscripcion.vue' /* webpackChunkName: "pages/confirmacion-suscripcion" */))
const _7ade7f90 = () => interopDefault(import('../../../pages/contacto.vue' /* webpackChunkName: "pages/contacto" */))
const _2418e95b = () => interopDefault(import('../../../pages/cursos/index.vue' /* webpackChunkName: "pages/cursos/index" */))
const _2391ca6a = () => interopDefault(import('../../../pages/empresas.vue' /* webpackChunkName: "pages/empresas" */))
const _63eae23e = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _73769952 = () => interopDefault(import('../../../pages/impacto-social.vue' /* webpackChunkName: "pages/impacto-social" */))
const _53d10ecc = () => interopDefault(import('../../../pages/instructores.vue' /* webpackChunkName: "pages/instructores" */))
const _767d9580 = () => interopDefault(import('../../../pages/nosotros.vue' /* webpackChunkName: "pages/nosotros" */))
const _e0dcd744 = () => interopDefault(import('../../../pages/politica-de-privacidad.vue' /* webpackChunkName: "pages/politica-de-privacidad" */))
const _37023833 = () => interopDefault(import('../../../pages/preguntas-frecuentes.vue' /* webpackChunkName: "pages/preguntas-frecuentes" */))
const _7fe6f302 = () => interopDefault(import('../../../pages/checkout/failure.vue' /* webpackChunkName: "pages/checkout/failure" */))
const _46c67c8f = () => interopDefault(import('../../../pages/checkout/pending.vue' /* webpackChunkName: "pages/checkout/pending" */))
const _8e5bc60a = () => interopDefault(import('../../../pages/checkout/success.vue' /* webpackChunkName: "pages/checkout/success" */))

const _05c516e4 = () => interopDefault(import('../../../pages/cursos/_curso.vue' /* webpackChunkName: "pages/cursos/_curso" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/404",
    component: _146c3e07,
    name: "404"
  }, {
    path: "/concretar-compra",
    component: _8d24550a,
    name: "concretar-compra"
  }, {
    path: "/confirmacion-contacto",
    component: _3c590a65,
    name: "confirmacion-contacto"
  }, {
    path: "/confirmacion-suscripcion",
    component: _5e59b1c6,
    name: "confirmacion-suscripcion"
  }, {
    path: "/contacto",
    component: _7ade7f90,
    name: "contacto"
  }, {
    path: "/cursos",
    component: _2418e95b,
    name: "cursos"
  }, {
    path: "/empresas",
    component: _2391ca6a,
    name: "empresas"
  }, {
    path: "/es",
    component: _63eae23e,
    name: "index___es"
  }, {
    path: "/impacto-social",
    component: _73769952,
    name: "impacto-social"
  }, {
    path: "/instructores",
    component: _53d10ecc,
    name: "instructores"
  }, {
    path: "/nosotros",
    component: _767d9580,
    name: "nosotros"
  }, {
    path: "/politica-de-privacidad",
    component: _e0dcd744,
    name: "politica-de-privacidad"
  }, {
    path: "/preguntas-frecuentes",
    component: _37023833,
    name: "preguntas-frecuentes"
  }, {
    path: "/checkout/failure",
    component: _7fe6f302,
    name: "checkout-failure"
  }, {
    path: "/checkout/pending",
    component: _46c67c8f,
    name: "checkout-pending"
  }, {
    path: "/checkout/success",
    component: _8e5bc60a,
    name: "checkout-success"
  }, {
    path: "/es/404",
    component: _146c3e07,
    name: "404___es"
  }, {
    path: "/es/concretar-compra",
    component: _8d24550a,
    name: "concretar-compra___es"
  }, {
    path: "/es/confirmacion-contacto",
    component: _3c590a65,
    name: "confirmacion-contacto___es"
  }, {
    path: "/es/confirmacion-suscripcion",
    component: _5e59b1c6,
    name: "confirmacion-suscripcion___es"
  }, {
    path: "/es/contacto",
    component: _7ade7f90,
    name: "contacto___es"
  }, {
    path: "/es/cursos",
    component: _2418e95b,
    name: "cursos___es"
  }, {
    path: "/es/empresas",
    component: _2391ca6a,
    name: "empresas___es"
  }, {
    path: "/es/impacto-social",
    component: _73769952,
    name: "impacto-social___es"
  }, {
    path: "/es/instructores",
    component: _53d10ecc,
    name: "instructores___es"
  }, {
    path: "/es/nosotros",
    component: _767d9580,
    name: "nosotros___es"
  }, {
    path: "/es/politica-de-privacidad",
    component: _e0dcd744,
    name: "politica-de-privacidad___es"
  }, {
    path: "/es/preguntas-frecuentes",
    component: _37023833,
    name: "preguntas-frecuentes___es"
  }, {
    path: "/es/checkout/failure",
    component: _7fe6f302,
    name: "checkout-failure___es"
  }, {
    path: "/es/checkout/pending",
    component: _46c67c8f,
    name: "checkout-pending___es"
  }, {
    path: "/es/checkout/success",
    component: _8e5bc60a,
    name: "checkout-success___es"
  }, {
    path: "/es/cursos/performance-de-apps-moviles-con-apptim-desktop",
    redirect: "/"
  }, {
    path: "/es/cursos/workshop-de-chaos-testing-y-chaos-engineering",
    redirect: "/"
  }, {
    path: "/es/cursos/software-tester-clase-en-vivo/",
    redirect: "/"
  }, {
    path: "/es/cursos/workshop-expedicion-al-mundo-del-testing-de-software/",
    redirect: "/"
  }, {
    path: "/es/cursos/:curso",
    component: _05c516e4,
    name: "cursos-curso___es"
  }, {
    path: "/cursos/:curso",
    component: _05c516e4,
    name: "cursos-curso"
  }, {
    path: "/",
    component: _63eae23e,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
